"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointErrorMessage = exports.PointErrorCode = exports.AppOnlyErrorMessage = exports.AppOnlyErrorCode = exports.MemberErrorMessage = exports.MemberErrorCode = void 0;
exports.MemberErrorCode = {
    NotExistMember: 'NOT_EXIST_MEMBER',
    NotExistAgreements: 'NOT_EXIST_AGREEMENTS',
    NotCertificatedMember: 'NOT_CERTIFICATED_MEMBER',
};
exports.MemberErrorMessage = (_a = {},
    _a[exports.MemberErrorCode.NotExistMember] = '회원정보를 찾을 수 없습니다.',
    _a[exports.MemberErrorCode.NotExistAgreements] = '동의정보를 찾을 수 없습니다.',
    _a[exports.MemberErrorCode.NotCertificatedMember] = '회원의 본인인증 정보를 찾을 수 없습니다.',
    _a);
exports.AppOnlyErrorCode = 'APP_ONLY_API';
exports.AppOnlyErrorMessage = '앱에서만 접근하실 수 있습니다';
exports.PointErrorCode = {
    InvalidRequest: 'INVALID_REQUEST',
    ExchangeLimitTryExceeded: 'EXCHANGE_LIMIT_TRY_EXCEEDED',
    ExchangeLimitAmountExceeded: 'EXCHANGE_LIMIT_AMOUNT_EXCEEDED',
    InvalidExchangeAmount: 'INVALID_EXCHANGE_AMOUNT',
    InternalServerError: 'INTERNAL_SERVER_ERROR',
};
exports.PointErrorMessage = (_b = {},
    _b[exports.PointErrorCode.InvalidRequest] = '잘못된 요청입니다.',
    _b[exports.PointErrorCode.ExchangeLimitTryExceeded] = '포인트 전환 횟수를 초과하였습니다.',
    _b[exports.PointErrorCode.ExchangeLimitAmountExceeded] = '포인트 전환 금액을 초과하였습니다.',
    _b[exports.PointErrorCode.InvalidExchangeAmount] = '잘못된 포인트 전환 금액입니다.',
    _b);
